import { axiosAjax } from './index'
import { DownLoadFile } from '../utils/index'

/**
 * 获取验证码
 * */
export function getCode(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/center/verify/getCode', data)
}

/**
 * 获取验证码(带滑动验证码)
 * */
export function getCodeByValid(data, apiHost) {
  const url = data.tencentVerify ? '/ticCenter/center/verify/getCodeByValid' : '/ticCenter/center/verify/getCode'
  return axiosAjax(apiHost + url, data)
}
/**
 * 密码登录
 * */
export function loginByPassword(data, apiHost) {
  return axiosAjax(apiHost + '/ticSso/sso/account/login', data)
}
/* 腾讯图形验证码 */
export function tencentCaptchaApi(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/third/verify/slide', data)
}
/**
 * 登录
 * */
export function checkCode(data, apiHost) {
  return axiosAjax(apiHost + '/ticSso/sso/account/userVerify', data)
}
export function ToolTypeQryByModel(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/tool/type/qryByModel', data)
}
export function GetProductBatch(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/center/enum/getBatch', data)
}
//合格证/水洗标保存接口
export function saveMakeToolRecord(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/saveMakeToolRecord', data)
}
//合格证/水洗标保存接口   美标
export function saveMakeToolRecordUSA(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/saveNAMakeToolRecord', data)
}
//合格证/水洗标保存接口  欧标
export function saveMakeToolRecordEUR(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/saveEUMakeToolRecord', data)
}
///合格证/水洗标查询接口(默认查询最新的一条数据)
export function qryMakeToolRecord(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/qryMakeToolRecord', data)
}
///合格证/水洗标查询接口(默认查询最新的一条数据)  美标
export function qryNAMakeToolRecord(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/qryNAMakeToolRecord', data)
}
///合格证/水洗标查询接口(默认查询最新的一条数据) 欧标
export function qryEUMakeToolRecord(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/qryEUMakeToolRecord', data)
}
//搜索成分
export function SearchComponent(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/qry', data)
}
//查询俗称
export function SearchFastFeek(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/fastFeek', data)
}
//重置合格证信息
export function ResetCertificateInformation(data, apiHost) {
  return axiosAjax(apiHost + '/ticMember/user/tool/resetHistoryData', data)
}
export function loginReg(data, apiHost) {
  return axiosAjax(apiHost + '/ticSso/business/account/loginReg', data)
}
/**
 * 获取IM
 * */
export function getIMtool(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/business/config/qry', data)
}
/*
* html转pdf
* params:html字符串
* fileName:下载文件名
* data:data对象
* loadingKey:按钮loadingKey
* */
export function html2pdf(params, fileName, apiHost, data, loadingKey) {
  if (data && loadingKey) {
    data[loadingKey] = true
  }
  axiosAjax(apiHost + "/ticCenter/business/api.v0.platform/fileUpload/content2PdfStream", params, undefined, true).then((res) => {
    if (data && loadingKey) {
      data[loadingKey] = false
    }
    DownLoadFile(res, fileName)
  }).catch(e => {
    console.log(e);
    if (data && loadingKey) {
      data[loadingKey] = false
    }
  })
}

export function getEnumBatch(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/business/api.v1.center/enum/getBatch', data)
}

export function qryLab(data, apiHost) {
  return axiosAjax(apiHost + '/ticCenter/business/api.v1.center/lab/qry', data)
}

export function qryBaseSample(data, apiHost) {
  return axiosAjax(apiHost + '/business/api.v2.order/sample/qryBaseSample', data)
}




